import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Pin = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Pin' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16,3 L10,9 C10,9 6,8 3,11 C3,11 13,21 13,21 C16,18 15,14 15,14 L21,8 L16,3 Z M1,23 L8,16 M14,1 L23,10' />
  </StyledIcon>
);
